import { makeAxiosRequest } from 'utils/apiMethods';

export default {
  updateDocumentTemplate: templateType => makeAxiosRequest(
    `/admin/document-templates/${templateType}`,
    { method: 'put' },
    true,
  ),
};
